module.exports = __webpack_public_path__ + "img/web.7f317b97.jpeg";